import { createRouter, createWebHistory } from "vue-router";

import Home from "../views/Home";

const routes = [
	{
		// Document title tag
		// We combine it with defaultDocumentTitle set in `src/main.js` on router.afterEach hook
		meta: {
			title: "Dashboard",
		},
		path: "/",
		name: "home",
		//component: Home,
		component: () => import(/* webpackChunkName: "rooms" */ "../views/ActiveRooms"),
	},
	{
		meta: {
			title: "Rooms",
		},
		path: "/rooms",
		name: "rooms",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/ActiveRooms"),
	},
	{
		meta: {
			title: "Booking Rooms",
		},
		path: "/booking_rooms",
		name: "booking_rooms",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/BookingRooms"),
	},
	{
		meta: {
			title: "History",
		},
		path: "/history",
		name: "history",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/History"),
	},
	{
		meta: {
			title: "Room history",
		},
		path: "/history/:roomId",
		name: "roomHistory",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/RoomHistory"),
	},
	{
		meta: {
			title: "Users",
		},
		path: "/users",
		name: "users",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/Users"),
	},
	{
		meta: {
			title: "Products",
			rootOnly: true,
		},
		path: "/products",
		name: "products",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/Products"),
	},
	{
		meta: {
			title: "Product create",
			rootOnly: true,
		},
		path: "/product/create",
		name: "productCreate",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/ProductCreate"),
	},
	{
		meta: {
			title: "Product upload",
			rootOnly: true,
		},
		path: "/product/upload",
		name: "productuUpload",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/ProductUpload"),
	},
	{
		meta: {
			title: "Product edit",
			rootOnly: true,
		},
		path: "/product/:productId",
		name: "productEdit",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/ProductEdit"),
	},
	{
		meta: {
			title: "Settings",
			rootOnly: true,
		},
		path: "/settings",
		name: "Settings",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/Settings"),
	},
	{
		meta: {
			title: "User create",
			rootOnly: true,
		},
		path: "/user/create",
		name: "userCreate",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/UserCreate"),
	},
	{
		meta: {
			title: "User edit",
		},
		path: "/user/:userId",
		name: "userEdit",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/UserEdit"),
	},
	{
		meta: {
			title: "Tables",
		},
		path: "/tables",
		name: "tables",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "tables" */ "../views/Tables"),
	},
	{
		meta: {
			title: "Forms",
		},
		path: "/forms",
		name: "forms",
		component: () => import(/* webpackChunkName: "forms" */ "../views/Forms"),
	},
	{
		meta: {
			title: "Profile",
		},
		path: "/profile",
		name: "profile",
		component: () => import(/* webpackChunkName: "profile" */ "../views/Profile"),
	},
	{
		meta: {
			title: "Change password",
		},
		path: "/password/change",
		name: "passwordChange",
		component: () => import(/* webpackChunkName: "login" */ "../views/ChangePassword"),
	},
	{
		meta: {
			title: "Security events",
			rootOnly: true,
		},
		path: "/security-events",
		name: "securityEvents",
		component: () => import(/* webpackChunkName: "rooms" */ "../views/SecurityEvents"),
	},
	{
		meta: {
			title: "Ui",
		},
		path: "/ui",
		name: "ui",
		component: () => import(/* webpackChunkName: "profile" */ "../views/Ui"),
	},
	{
		meta: {
			title: "Login",
			formScreen: true,
		},
		path: "/login",
		name: "login",
		component: () => import(/* webpackChunkName: "login" */ "../views/Login"),
	},
	{
		meta: {
			title: "Forgot password",
			formScreen: true,
		},
		path: "/password/forgot",
		name: "passwordForgot",
		component: () => import(/* webpackChunkName: "login" */ "../views/ForgotPassword"),
	},
	{
		meta: {
			title: "Reset password",
			formScreen: true,
		},
		path: "/password/reset",
		name: "passwordReset",
		component: () => import(/* webpackChunkName: "login" */ "../views/ResetPassword"),
	},
];

const router = createRouter({
	mode: "history",
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		return savedPosition || { top: 0 };
	},
});

export default router;
